const current = {
  backgroundColor: ({ theme }) => theme.colors.hjortron,
  borderColor: ({ theme }) => theme.colors.mellanbla,
  borderRadius: 0,
}

export default current
